import React from 'react';
export function setRef(ref, node) {
    if (!ref) {
        return;
    }
    if (typeof ref === 'function') {
        ref(node);
        return;
    }
    ref.current = node;
}
export function setRefs(refs, node) {
    refs.forEach((ref)=>setRef(ref, node));
}
